import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssGrid } from "styles/helpers/layout";

export const StyledInviteOptionBox = styled(CssGrid)<Props>`
  grid-template-columns: 3rem 1fr;
  padding: 1rem;
  column-gap: 1rem;
  border-radius: 1rem;
  border: solid 1px ${(props: Props) => props.theme.palette.neutral._900};

  :hover {
    cursor: pointer;
    background: ${(props: Props) => props.theme.palette.neutral._999};
  }
`;

export const StyledProList = styled.ul<Props>`
  margin: 0;
  list-style: none;
  padding: 0 0.5rem;

  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;

  li {
    font-size: ${(props: Props) => props.theme.font.size._14};
  }

  li:before {
    content: '✓';
    padding-right: 1rem;
    color: ${(props: Props) => props.theme.palette.feedback.success.brand};
  }
`;
